<app-thesis-report-view *ngIf="isReady && report?.Status == 'Registered'" [report]="report"></app-thesis-report-view>
<app-thesis-report-edit *ngIf="isReady && report?.Status != 'Registered'" [report]="report"></app-thesis-report-edit>
